// extracted by mini-css-extract-plugin
export default {"header":"LV0BID","successActions":"cSW2Kf","desktop":"cgKlmr","title":"RdmUII","mobile":"UJkRwt","spinnerContainer":"TCLrk6"};